import { TValidSdcColumns } from './../../sdc-columns.type';
import { DEFAULT_SORT } from './../default-sort.constant';
import { sdcStateConfigConstant } from './../sdc-state-config.constant';
import {
  IColumnSort,
  IFilter,
  IGridViews,
  ISdcActivity,
  TValidSdcStates,
  TValidSdcViews,
} from './../sdc-state.typings';

export class AttendanceConfigService implements ISdcActivity {
  get humanName() {
    return sdcStateConfigConstant.ATTENDANCE.humanName;
  }

  get state(): TValidSdcStates {
    return sdcStateConfigConstant.ATTENDANCE.state;
  }

  get columns(): TValidSdcColumns[] {
    return [
      'studentId',
      'studentName',
      'cohort',
      'seniorFlag',
      'status',
      'grade',
      'officialClass',
      'atsCounselor',
      'advisor',
      'iep',
      'ell',
      'attendanceYtd',
      'attendanceYtdFilter',
      'gradPlan',
      'currentCourses',
      'currentCourseCodes',
      'totalCreditsEarned',

      'attdThreat',
      'transitDistanceMiles',
      'transitTimeMinutes',
      'attendance8thGrade',
      'attendanceThreeSyPrior',
      'attendanceTwoSyPrior',
      'attendancePriorSy',
      'percentDaysLateYtd',
      'percentDaysLatePriorSy',
      'countOfDaysAbsentLast10Days',
      'numberOfDaysAbsentLast5Days',
      'numberOfDaysAbsentYtd',
      'tempResFlag',
      'housingStatus',

      // added for community schools on 3/22
      'schoolPriorityFlag',
    ];
  }

  get hiddenColumns(): TValidSdcColumns[] {
    return [];
  }

  get gridViews(): IGridViews {
    return {};
  }

  get filter(): IFilter {
    return {
      status: ['A'],
    };
  }

  get sort(): IColumnSort[] {
    return DEFAULT_SORT;
  }

  get bundleName() {
    return 'ATTENDANCE';
  }

  get availableSdcViews(): TValidSdcViews[] {
    return sdcStateConfigConstant.ATTENDANCE.availableSdcViews;
  }
}
